export const INDIAN_STATES = [
  "Karnataka",
  "Telangana",
  "Maharashtra",
  "Others"
];

export const INDIAN_CITIES = [
  "Bengaluru" , "Mysuru" , "Tumkur", 
  "Hyderabad" , "Secunderabad" , "Mumbai", "Navi Mumbai", "Pune" , "Thane", "Warangal"
];


export const CITY_MAP: Record<string, string[]> = {
  Karnataka: ["Bengaluru", "Mysuru", "Tumkur"],
  Telangana: ["Hyderabad", "Secunderabad", "Warangal"],
  Maharashtra : ["Mumbai", "Navi Mumbai", "Pune", "Thane"],
  Others : ["Others"]
};



